module.exports = __webpack_public_path__ + "img/maternidade.8695b48d.png";